import {
    REQUEST_START,
    REQUEST_SUCCESS,
    REQUEST_FAILURE
} from "./actions";

const initialState = {
    requesting: false,
    error: {},
    success: false
};

export default (state = {}, action) => {
    const newState = Object.assign({}, initialState, state);

    switch (action.type) {
        case REQUEST_START:
            newState.requesting = true;
            newState.success = false;
            newState.error = {};
        break;
        case REQUEST_SUCCESS:
            newState.requesting = false;
            newState.success = true;
            newState.error = {};
        break;
        case REQUEST_FAILURE:
            newState.requesting = false;
            newState.success = false;
            newState.error = action.payload;
        break;
        default:
        break;
    }

    return newState;
}


// WEBPACK FOOTER //
// ./src/components/app/forgot-password/reducer.js